import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_DP_CREATE_WATCH_PARTY]: 'Watch Party',
  [StringId.DV_DP_WATCH_PARTY_TOOLTIP]: 'Watch and chat with your friends',
  [StringId.DV_DP_WATCH_PARTY_FTUE_HEADER]: "NEW",
  [StringId.DV_DP_WATCH_PARTY_FTUE_BODY]: "Create a Watch Party to watch and chat with others.",
}



